(function (){
    'use strict';

    angular
        .module('auth')
        .controller('PartnerLoginController', PartnerLoginController)
    PartnerLoginController.$inject = ['AuthService','$state','jwtHelper','AclService'];

    function PartnerLoginController(AuthService, $state, jwtHelper, AclService) {
        var vm = this;
        vm.email = '';
        vm.password = '';
        vm.processing = '';
        vm.submit = submit;
        vm.message = null;

        function activate () {

        }

        function submit () {
            vm.processing = true;
            AuthService.loginPartners(vm.email, vm.password)
            .then( function () {
                return AuthService.getCurrentUser();
            })
            .then( function (user) {
                if(typeof user.getType !== 'undefined' && user.getType === 'partner'){
                    console.log('Redirect to partner dashboard');
                    $state.go('root.partner.dashboard');
                }
                else{
                    console.log('Redirect to user dashboard');
                    $state.go('root.dashboard');
                }
            }).catch(function (err) {
                vm.message = 'Invalid Email / Password';
            }).finally ( function () {
                vm.processing = false;
            });
        }
        activate();
    }
})();